import axios from "axios";
import baseurl from "./baseUrl";
import Router from "../router"
// 单独引入 Message
import { Message } from 'element-ui'
const $service = axios.create();
$service.defaults.baseURL = baseurl;
$service.defaults.timeout = 100000;
$service.defaults.headers.post["Content-Type"] = "application/json";
$service.defaults.headers.put["Content-Type"] = "application/json";
//请求拦截器
$service.interceptors.request.use(
  config=>{
    // console.log("进入请求拦截器...");
    if(sessionStorage.getItem("access_token")){
      // console.log("请求头携带token...");
      config.headers.BookToken='Bearer '+sessionStorage.getItem("access_token");
      // console.log(config.headers)
    }
    return config;
  },
  error=>{
    console.log("===发送请求拦截器报错===")
    console.log(error);
    console.log("===end===");
    Promise.reject(error);
  }
);
// 响应拦截器
$service.interceptors.response.use(
  response => {
    // console.log("触发响应拦截器...")
    // 如果返回的状态码为200，说明接口请求成功，可以正常拿到数据,否则的话抛出错误
    if (response.status === 200) {
      if(response.data.code==401){
        // Message({
        //       message: '登录超时，请重新登录',
        //       center: true,
        //       duration: 1500,
        //       type:'error',
        //     });
            sessionStorage.removeItem("access_token");
            Router.replace('/ssoLogin')
      }
      return Promise.resolve(response)
    } else {
      return Promise.reject(response)
    }
  },
  error => {
    if (error.response.status) {
      switch (error.response.status) {
        //无权限
        case 500:
          Message({
            message: '登录超时，请重新登录',
            center: true,
            duration: 1500,
            type:'error',
          });
          sessionStorage.removeItem("access_token");
          Router.replace('/login')
          break
        //拒绝请求403
        case 403:
          Message({
            message: '无权限访问该网站',
            center: true,
            duration: 1500,
            type:'error',
          });
          sessionStorage.removeItem("access_token");
          break
        // 404请求不存在
        case 404:
          Message({
            message: '网络请求不存在',
            center: true,
            duration: 1500,
            type:'error',
          });
          break
          // 其他错误，直接抛出错误提示
        default:
          Message({
            message: error.response.data.message,
            duration: 1500,
            type:'error',
          })
      }
      return Promise.reject(error.response)
    }
  }
)
// get请求 尚未利用qs序列化参数
export function get (url, params) {
  return new Promise((resolve, reject) => {
    $service.get(url, {
      params: params
    }).then(res => {
      resolve(res)
    }).catch(err => {
      reject(err)
    })
  })
}

// post请求，
export function post (url, data) {
  return new Promise((resolve, reject) => {
    $service.post(url, JSON.stringify(data))
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}
/**
 * 封装put请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function put (url, data) {
  return new Promise((resolve, reject) => {
    $service.put(url, JSON.stringify(data)).then(res => {
      resolve(res)
    }).catch(err => {
      reject(err)
    })
  })
}
/**
 * delete
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function deletefn(url, params) {
  return new Promise((resolve, reject) => {
    $service.delete(url, {
      params: params})
          .then(res => {
              resolve(res.data);
          })
          .catch(err => {
              reject(err.data)
          })
  });

}
